export const COMPETITOR_TYPES = ['primary', 'secondary', 'category'];

export function validateCompetitorBrandName(value) {
  const name = (value ?? '').trim();
  if (!name) return 'Brand name is required.';
  return '';
}

export function buildCreateCompetitorPayload(clientId, form) {
  return {
    client_id: clientId,
    brand_name: (form.brand_name ?? '').trim(),
    domain: (form.domain ?? '').trim(),
    competitor_type: form.competitor_type || 'primary',
  };
}

export function competitorApiError(err) {
  const status = err?.response?.status;
  const detail = err?.response?.data?.detail;
  const detailText = typeof detail === 'string' ? detail : '';
  if (status === 401) return 'Your session expired. Please sign in again.';
  if (status === 403) return detailText || 'You do not have permission to manage competitors.';
  if (status === 404) return 'Client not found.';
  if (status === 400) return detailText || 'Please check the form and try again.';
  if (status === 500) return 'A server error occurred. Please try again later.';
  return detailText || err?.message || 'Something went wrong.';
}
